var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "def-w" }, [
    _c("div", { staticClass: "flex" }, [
      _c("div", { staticClass: "left" }, [
        _c("div", { staticClass: "left-img" }, [
          _c("img", { attrs: { src: _vm.menuBgImg, alt: "" } }),
          _c("h3", { staticClass: "left-title" }, [
            _vm._v(_vm._s(_vm.parentInfo.name)),
          ]),
        ]),
        _c(
          "ul",
          { staticClass: "cate-list" },
          _vm._l(_vm.cateList, function (item) {
            return _c(
              "li",
              {
                key: item.code,
                staticClass: "cate-item",
                on: {
                  click: function ($event) {
                    return _vm.selectCate(item.code)
                  },
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "cate-title",
                    class: { active: _vm.code === item.code },
                  },
                  [_vm._v(_vm._s(item.name))]
                ),
              ]
            )
          }),
          0
        ),
      ]),
      _c(
        "div",
        { staticClass: "right flex-1" },
        [_c("router-view", { attrs: { "cate-info": _vm.curCateInfo } })],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }